
        <div class="detalle__movimiento">
          <div class="detalle__title-2">
              <h2>Centros de Atención</h2>
              <div class="btn-group">
                  <label>Buscar</label>
                  <input type="text" [(ngModel)]="filter" placeholder="Ingrese búsqueda" [attr.disabled]="error ? true : loading ? true : null">
              </div>
          </div>
          <div class="movimientos movimientosComponent">
              <div  class="movimientos__items">
                <div>
                      <h2>Distrito</h2>
                  </div>
                  <div>
                      <h2>Ubicación</h2>
                  </div>
                  <!-- <div>
                      <h2>Dirección</h2>
                  </div> -->
              </div>
              <div *ngIf="error" class="alert red"><p>{{ msjError }}</p></div>
              <ng-container *ngIf="(centros | filter:filter) as result">
                <div *ngIf="result.length === 0" class="alert red"><p>No se encontraron registros</p></div>
                <div  *ngFor="let data of result; let i= index" class="movimientos__items content">
                    <div class="body">
                          <h2>Distrito</h2>
                          <p>{{ data.sDesLargo03 }}</p>
                      </div>
                      <div class="body">
                          <h2>Ubicación</h2>
                          <p>{{ data.sDesLargo01 }}</p>
                      </div>
                      <!-- <div class="body">
                          <h2>Dirección</h2>
                          <p>{{ data.sDesLargo02 }}</p>
                      </div> -->
                  </div>
              </ng-container>
              <!-- <ng-container *ngIf="(centros | filter:filter) as result">
                <div *ngIf="result.length === 0" class="alert red"><p>No se encontraron registros</p></div>
                <div  *ngFor="let data of result; let i= index" class="movimientos__items content">
                      <div class="body">
                          <h2>Zona</h2>
                          <p>{{ data.sDesCorto01 }}</p>
                      </div>
                      <div class="body">
                          <h2>Dirección</h2>
                          <p>{{ data.sDesLargo02 }}</p>
                      </div>
                  </div>
              </ng-container> -->
          </div>
      </div>
